import { generateUrlParams } from "../../utils/generateUrlParams";
const baseUrl = "Supplementary";

export const supplementaryLoadApplicationFormUrl = (jambRegNumber) =>
	`${baseUrl}/load-supplementary-application-form?regNumber=${jambRegNumber}`;

export const supplementaryPersonalDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-supplementary-application-personal-details-and-programme`;

export const staffRequestLoadApplicationFormUrl = (jambRegNumber) =>
	`${baseUrl}/load-staff-request-application-form?jambNumber=${jambRegNumber}`;

export const staffRequestStaffDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-staff-request-application-personal-details`;

export const loadSupplementaryDiplomaApplicationFormUrl = (filter) => `${baseUrl}/load-diploma-supplementary-application-form?${generateUrlParams(filter)}`;

export const supplementaryDiplomaPersonalDetailsFormUrl = () => `${baseUrl}/add-or-update-diploma-supplementary-application-personal-details-and-programme`;